<ng-container *ngFor="let data of currencys">
  <button type="button" class="btn btn-outline-primary btn-sm me-2 mb-3" (click)="onSubmit(data)" [ngClass]="{'active':currency == data.currency}" [disabled]="!data.supported">
    <div class="d-flex">
      <img [src]="data.img_flag+'?t=1'" width="30px" alt="{{data.currency}}">
      <div class="text-start ps-2 me-2">
        {{data.currency}}
        <small class="d-block opacity-50">
          {{data.description}}
        </small>
      </div>
      <div class="border-start" style="width: 50px;">
        {{data.game_count || 0}}
        <small class="d-block">GAMES</small>
      </div>
    </div>
  </button>
</ng-container>
